// import external libraries
import { useState } from 'react';

// import hooks
import useSubNavigation from 'hooks/useSubNavigation';
import { queries } from 'RestAPIs/rapini';
import { useGetPatientDetails } from './queries';

// import types
import type { Patient } from './types';

enum TabType {
  PATIENT_INFO = 'patient-info',
  PRESCRIPTIONS = 'prescriptions',
  TREATMENTS = 'treatments'
}

export { TabType };

export const useCareReceiversHome = () => {
  const [subPage, setSubPage] = useState<TabType>(TabType.PATIENT_INFO);
  const { setPage } = useSubNavigation<TabType>(
    TabType.PATIENT_INFO,
    'page',
    setSubPage
  );

  const onTabChanged = (_, newValue: TabType) => {
    setPage(newValue, undefined, true);
  };

  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null);

  const onSelectPatient = (patient: Patient | null) => {
    setSelectedPatient(patient);
  };

  const { data: patientDetails, isLoading: isLoadingDetails } =
    useGetPatientDetails(selectedPatient);

  const { data: prescriptions, isLoading: isLoadingPrescriptions } =
    queries.useGetPrescriptions(selectedPatient?.entityId!, {
      enabled: !!selectedPatient?.entityId
    });

  return {
    subPage,
    onTabChanged,
    selectedPatient,
    onSelectPatient,
    patientDetails,
    isLoadingDetails,
    prescriptions,
    isLoadingPrescriptions
  };
};
